/**
 * Cheap assign-checkbox sync for smart-rendered rows.
 * Selection must not rebuild `ganttColumns` / ReactGantt config — paint visible
 * inputs from the selection Set instead (same idea as pending-row highlights).
 */

export function assignSelectAllHeaderState(
  selectedIds: ReadonlySet<string>,
  selectableIds: ReadonlySet<string>,
): { checked: boolean; indeterminate: boolean } {
  if (selectableIds.size === 0) {
    return { checked: false, indeterminate: false };
  }
  let selectedCount = 0;
  for (const id of selectableIds) {
    if (selectedIds.has(id)) selectedCount += 1;
  }
  if (selectedCount === 0) {
    return { checked: false, indeterminate: false };
  }
  if (selectedCount === selectableIds.size) {
    return { checked: true, indeterminate: false };
  }
  return { checked: false, indeterminate: true };
}

export function syncAssignSelectCheckboxes(
  root: ParentNode,
  selectedIds: ReadonlySet<string>,
  selectableIds: ReadonlySet<string>,
): void {
  root.querySelectorAll('.gantt-assign-select-checkbox').forEach((node) => {
    const el = node as HTMLInputElement;
    const id = el.getAttribute('data-task-id');
    if (id == null) return;
    const next = selectedIds.has(id);
    if (el.checked !== next) el.checked = next;
  });

  root
    .querySelectorAll('.gantt_row[data-task-id], .gantt_task_row[data-task-id]')
    .forEach((node) => {
      const el = node as HTMLElement;
      const id = el.getAttribute('data-task-id');
      if (id == null) return;
      el.classList.toggle('gantt-row-assign-selected', selectedIds.has(id));
    });

  const header = root.querySelector('.gantt-assign-select-all');
  if (header instanceof HTMLInputElement) {
    const { checked, indeterminate } = assignSelectAllHeaderState(
      selectedIds,
      selectableIds,
    );
    if (header.checked !== checked) header.checked = checked;
    if (header.indeterminate !== indeterminate) header.indeterminate = indeterminate;
  }
}
